export default "__VITE_ASSET__BgbwuVMQ__"